import InnerComponent from '@Components/Purchase/DebitNotes/DebitNoteForm';
import orgContainer from '@Components/AppContainer';

const CreateDebitNotePage = () => ((orgContainer(InnerComponent)));
export default CreateDebitNotePage;
